module.exports = __webpack_public_path__ + "340aced8c04597efc14e1407c6a1eeea.png";